<highcharts-chart
  class="m-donut-chart"
  [Highcharts]="Highcharts"
  [options]="chartOptions">
</highcharts-chart>
